import { formatDate, formatNumber } from 'devextreme/localization';
import { useContext } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Field, Panel } from '../../../../layouts';
import { OrderStatus } from '../../../../types/enums';
import { RetailOrderContext } from '../../retail-order/context/RetailOrderContext';
import { MaterialOrderContext } from '../context/MaterialOrderContext';

export default function MaterialOrderInformationPanel() {

	const { order } = useContext(MaterialOrderContext);
	const { order: retailOrder } = useContext(RetailOrderContext);

	const totalMoAmount = retailOrder.details?.materialOrders.reduce((a, b) => a + b.amount, 0);
	const totalFinLinkAmount = retailOrder.details?.materialOrders.reduce(
		(a, b) => a + (b.finLink && b.orderStatusID !== OrderStatus.Cancelled ? b.amount : 0), 0);

	const [params] = useSearchParams();
	const returnUrl = encodeURIComponent(params.get("returnUrl") ?? "");

	return (
		<>
			<Panel
				header={'Material Order Information'}
			>
				<Field label={'MO Number'} >{order.details.moNumber}</Field>
				<Field label={'Order Type'} >{order.details.moType}</Field>
				<Field label={'Order Status'} >{order.details.orderStatus}</Field>
				<Field label={'Order Date'} >{formatDate(new Date(order.details.moDate), 'shortDate')}</Field>
				<Field label={'Amount'} >{formatNumber(order.details.amount, { type: 'currency', precision: 2 })}</Field>
				{
					retailOrder.details &&
					<Field label={'Material Orders'}>
						<table className='material-orders material-orders-with-selector'>
							<tbody>
								{
									retailOrder.details.materialOrders.map((mo) => {
										return (
											<tr key={mo.materialOrderID}>
												<td className='material-order-selector'>
													{mo.materialOrderID === order.details.materialOrderID ? "➤" : ""}
												</td>
												<td>
													<Link to={'/cfi/retail-order/' + retailOrder.details.retailOrderID + '/130/' + mo.materialOrderID +
														(!!returnUrl ? '?returnUrl=' + returnUrl : '')}>
														{mo.moNumber}
													</Link>
												</td>
												<td>
													{formatNumber(mo.amount, { type: 'currency', precision: 2 })}
												</td>
												<td></td>
											</tr>
										)
									})
								}
								<tr>
									<td></td>
									<td></td>
									<td className='mo-total'>
										{formatNumber(totalMoAmount, { type: 'currency', precision: 2 })}
									</td>
									<td>
										({formatNumber(totalFinLinkAmount / retailOrder.details.amount, { type: 'percent', precision: 0 })})
									</td>
								</tr>
							</tbody>
						</table>
					</Field>
				}
			</Panel>
		</>
	);
}
